<template>
    <component :is="component" :form="form" :dialog="dialog" :booking="booking" @save="onSave" @refresh="onRefresh" @update="onUpdate" @close="onClose"/>
</template>
<script>
import admin from './edit_admin'
import simple from './edit_simple'
export default {
  props: ['dialog', 'form', 'booking'],
  components: {
    admin,
    simple
  },
  data() {
    return {
      component: 'simple'
    }
  },
  methods: {
    onSave (result) {
      this.$emit('save', result);
    },
    onUpdate (result) {
      this.$emit('update', result);
    },
    onClose (result) {
      this.$emit('close', result);
    },
    onRefresh (result) {
      this.$emit('refresh', result);
    }
  },
  computed: {
    user: {
      cache: false,
      get () {
        return this.$store.getters.user
      }
    }
  },
  mounted() {
    if (this.user.role === "super" || this.user.role === "lead") {
      this.component =  'admin'
    }
  }
}
</script>
<style lang="scss">

</style>
